import PropTypes from "prop-types";
import { useState } from "react";
import { EyeIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import EmailHtmlFrame from "components/email/EmailHtmlFrame";

// A fixed height instead of autoHeight: autoHeight measures the body once on
// load and can settle on a few pixels, which left the inline preview as a
// strip the user had to scroll inside.
const FRAME_STYLE = { height: "70vh" };

/** The saved template body at full size, in a dialog. */
const EmailTemplatePreviewDialog = ({ html, name }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="button" variant="outline" onClick={() => setOpen(true)}>
        <EyeIcon data-icon="inline-start" />
        Preview
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="tw:sm:max-w-5xl">
          <DialogHeader>
            <DialogTitle>Preview</DialogTitle>
            <DialogDescription>
              {name
                ? `The saved body of "${name}", without merge data.`
                : "The saved template body, without merge data."}
            </DialogDescription>
          </DialogHeader>
          <div className="tw:overflow-hidden tw:rounded-lg tw:border tw:border-(--color-border)">
            <EmailHtmlFrame
              title="Email template preview"
              html={html}
              style={FRAME_STYLE}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

EmailTemplatePreviewDialog.propTypes = {
  html: PropTypes.string.isRequired,
  name: PropTypes.string,
};

export default EmailTemplatePreviewDialog;
